import * as Yup from 'yup';
export const YupValidateEditRequestRetire = () => {
	const validationSchema = Yup.object().shape({

	});
	return validationSchema;
};
